<template>
  <v-card variant="flat" class="d-flex align-center justify-space-between transparent-card pa-1">
    <sf-color-text ref="status" :color="getPortalOrderStatusColor(orderStatus)">
      {{ $t('orderStatus.' + orderStatus) }}
    </sf-color-text>
    <topi-badge v-if="isTopi" />
  </v-card>
</template>

<script setup lang="ts">
import SfColorText from '@/components/text/SfColorText.vue'
import { getPortalOrderStatusColor } from '@/modules/order/helpers'
import TopiBadge from '@/modules/topi/components/TopiBadge.vue'
import { PortalOrderStatus } from '@/types/index'
import { PropType } from 'vue'

defineProps({
  orderStatus: {
    type: String as PropType<PortalOrderStatus>,
    required: true
  },
  isTopi: {
    type: Boolean,
    required: true
  }
})
</script>
